export function getColor(name: string): string {
  return `var(--dnv-color-${name})`;
}
